<template>
  <div class="menu-wrp-outer" :class="{'color-white':$route.meta.logo.color === '#FFFFFF'}">
      <div @click="show = true" class="menu-wrp-inner">
          <p class="menu-text">Menu</p>
          <div class="menu-trigger"></div>
      </div>
      <transition name="fade-up">
          <ul v-if="show" class="menu-list-wrp">
              <li class="menu-list-close-trigger-wrp">Menu<img @click.stop="show = false" src="../../assets/img/black-ex.svg" alt=""></li>
              <li><router-link to="/work">Work</router-link></li>
              <li><router-link to="/about">About</router-link></li>
              <li><router-link to="/contact">Contact</router-link></li>
          </ul>
      </transition>
  </div>
</template>

<script>
export default {
    data(){
        return{
            show:false
        }
    },

    watch:{
        $route:{
            handler(){
                this.show = false
            },
            deep:true
        }
    }
}
</script>

<style>
.menu-wrp-outer{
    position: relative;
    user-select: none;
    z-index: 3;
}

.menu-wrp-inner{
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    height: 30px;
}

.menu-text{
    font-size: 21px;
    font-weight: 300;
    color: black;
}

.menu-wrp-outer.color-white .menu-text{
    color: white;
}

.menu-trigger{
    margin-left: 15px;
    width: 30px;
    height: 2px;
    background-color: black;
    position: relative;
}

.menu-wrp-outer.color-white .menu-trigger{
    background-color: white;
}

.menu-trigger::before,
.menu-trigger::after{
    display: block;
    content: '';
    width: 25px;
    height: 2px;
    background-color: black;
    position: absolute;
}

.menu-wrp-outer.color-white .menu-trigger::before,
.menu-wrp-outer.color-white .menu-trigger::after{
    background-color: white;
}

.menu-trigger::before{
    top: -8px;
}

.menu-trigger::after{
    bottom: -8px;
}

.menu-list-wrp{
    position: absolute;
    top: 0;
    right: 0;
    padding: 28px;
    padding-top: 15px;
    background-color: white;
    box-shadow: 0 3px 6px #00000029;
    border-radius: 10px;
    list-style:none;
}

.menu-list-wrp li{
    color: black;
    font-size: 24px;
    line-height: 55px;
    font-weight: 300;
    width: 225px;
    display: flex;
    align-items: center;
}

.menu-list-close-trigger-wrp{
    font-weight: 500!important;
    display: flex;
    justify-content: space-between;
}

.menu-list-close-trigger-wrp img{
    cursor: pointer;
    width: 21px;
}

@media screen and (max-width: 589px){
    .menu-text{
        display: none;
    }
    .menu-list-wrp{
        top: -10px;
    }
}

@media screen and (max-width: 320px){
    .menu-list-wrp{
        padding: 20px;
    }
    .menu-list-wrp li{
        font-size: 20px;
        line-height: 50px;
    }
}

</style>